import styled from "styled-components";

export const SubHeaderTitleCss = styled.div`
  .common__linkTags{
    font-size: 20px;
    padding-right: 8px;
  }
  .common__subtitle{
    padding-left: 8px;
  }
`;
